/* eslint-disable*/
import React from "react";
import { Redirect, Route } from "react-router";
import { useQuery } from "react-query";
import { QUERY_AUTH } from "../../services/auth/queries";
import isEmpty from "ramda/src/isEmpty";

const AuthRoute = ({ component: Component, exact, path }) => {
  const { data: user } = useQuery(QUERY_AUTH);
  const isAuthenticated = !isEmpty(user);

  return (
    <Route
      exact={exact}
      path={path}
      render={(props) =>
        !isAuthenticated ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/tickets",
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};

export default AuthRoute;
